import { useState } from 'react';
import { PiGearDuotone, PiMicrosoftExcelLogoDuotone } from 'react-icons/pi';

import { Translate } from '@spazious/dollhouse-i18n';
import {
  Button,
  ButtonProps,
  Flex,
  Stack,
  StackProps,
  Tooltip,
  Typography,
} from '@spazious/dollhouse-uikit';

import { CloseButton } from '../CloseButton/index.js';
import { CSVDialog } from '../CSVDialog/index.js';
import { SettingsDialog } from '../SettingsDialog/index.js';

export interface MenuDialogButtonsProps extends StackProps {
  buttonSize?: ButtonProps['size'];
}

export const MenuDialogButtons: React.FC<MenuDialogButtonsProps> = ({
  buttonSize = 'medium',
  ...restProps
}) => {
  const [open, setOpen] = useState<'export' | 'settings' | null>(null);

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <Stack column {...restProps}>
      <Tooltip
        content={
          <Flex padding="2rem">
            <Typography>
              <Translate>Download the current layout</Translate>
            </Typography>
            <CloseButton onClick={handleClose} />
          </Flex>
        }
      >
        <Button
          size={buttonSize}
          onClick={() => {
            setOpen('export');
          }}
        >
          <PiMicrosoftExcelLogoDuotone />
        </Button>
      </Tooltip>
      <CSVDialog open={open === 'export'} onClose={handleClose} />
      <Button
        size={buttonSize}
        onClick={() => {
          setOpen('settings');
        }}
      >
        <PiGearDuotone />
      </Button>
      <SettingsDialog open={open === 'settings'} onClose={handleClose} />
    </Stack>
  );
};
